import { Component, ViewChild, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pfs-autocomplete',
  templateUrl: './pfs-autocomplete.component.html',
  styleUrls: ['./pfs-autocomplete.component.scss']
})
export class PfsAutocompleteComponent implements OnChanges {

  @ViewChild('searchTextField', { static: false }) searchTextField: any;
  @Output() placeSelected = new EventEmitter<any>();
  @Input() pfsLabel: string;
  @Input() pfsList: any;

  pfsControl = new FormControl();
  pfsOptions: any;
  environment = environment;
  autocomplete: any;

  get inputLabel() {
    return this.pfsLabel ? this.pfsLabel : '';
  }

  ngOnChanges() {
    this._initAutoComplete();
  }

  emitPfs(e) {
    this.pfsControl.setValue(e.code);
    this.placeSelected.emit({ point: e, isValid: true });
  }

  private _filter = (value: string | any, list): string[] => {
    const isEntireObject = value instanceof Object;
    return list.filter((option) =>
      option.code
        .toLowerCase()
        .includes(
          !isEntireObject ? value.toLowerCase() : value.code.toLowerCase(),
        ),
    );
  };

  private _initAutoComplete() {
    if (this.pfsList && this.pfsList.length) {
      this.pfsOptions = this.pfsControl.valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(value as string, this.pfsList)),
      );
    }
  }

}
